import { changeDateFormat, PRICE_CALENDAR_API_DATE_FORMAT } from '@/app/components/hotel-detail/common/dates';

export const PRODUCT_DETAIL_PRICE_CALENDAR_CLICKED = 'PRODUCT_DETAIL_PRICE_CALENDAR_CLICKED';
export const PRODUCT_DETAIL_PRICE_CALENDAR_CLICKED_VERSION = '1.0';

export type PriceCalendarClickedPayload = {
  productDetailKey: string;
  currency: string;
  departureDate: string;
  totalPrice?: number;
};

export type PriceCalendarClickedParams = {
  productDetailKey: string;
  currency: string;
  datefrom: string;
  price: number | undefined;
};

export const createPriceCalendarClickedPayload = ({
  productDetailKey,
  currency,
  datefrom,
  price,
}: PriceCalendarClickedParams): PriceCalendarClickedPayload => {
  const dateFromFormatted = changeDateFormat(datefrom, PRICE_CALENDAR_API_DATE_FORMAT, 'yyyyMMdd');

  return {
    productDetailKey,
    currency,
    departureDate: dateFromFormatted,
    totalPrice: Math.floor(price ?? 0), // The StarTrack event is defined as an int so we cannot have fractions.
  };
};
